import { render, staticRenderFns } from "./validPhone.vue?vue&type=template&id=0482ec38&scoped=true"
import script from "./validPhone.vue?vue&type=script&lang=js"
export * from "./validPhone.vue?vue&type=script&lang=js"
import style0 from "./validPhone.vue?vue&type=style&index=0&id=0482ec38&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0482ec38",
  null
  
)

export default component.exports